import * as React from "react";
const SvgReject = (props) => /* @__PURE__ */ React.createElement("svg", { width: 12, height: 12, xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M1 11l9.8-10m0 10L1 1", stroke: "currentColor", strokeWidth: 1.8, fill: "none", strokeLinecap: "round" }));
export { SvgReject as ReactComponent };
